module.exports = "<div class=\"flex-container\" *ngIf=\"show\">\n  <img src=\"../../assets/picture/loding/loading.gif\">\n</div>\n"